<script setup lang="ts">
import { Angry, Annoyed, BicepsFlexed, Frown, Heart, Laugh, Meh, PartyPopper, Smile, ThumbsDown, ThumbsUp } from '@lucide/vue';
import { OtSlider } from './slider';
import OtSubheader from './Subheader.vue';

interface Props {
    modelValue: number;
    label: string;
}
defineProps<Props>();
</script>

<template>
    <div class="p-4">
        <ot-subheader>
            <angry v-if="modelValue === 0" class="w-8 h-8 mr-4" />
            <frown v-if="modelValue === 1" class="w-8 h-8 mr-4" />
            <annoyed v-if="modelValue === 2" class="w-8 h-8 mr-4" />
            <meh v-if="modelValue === 3" class="w-8 h-8 mr-4" />
            <thumbs-down v-if="modelValue === 4" class="w-8 h-8 mr-4" />
            <smile v-if="modelValue === 5" class="w-8 h-8 mr-4" />
            <thumbs-up v-if="modelValue === 6" class="w-8 h-8 mr-4" />
            <biceps-flexed v-if="modelValue === 7" class="w-8 h-8 mr-4" />
            <laugh v-if="modelValue === 8" class="w-8 h-8 mr-4" />
            <party-popper v-if="modelValue === 9" class="w-8 h-8 mr-4" />
            <heart v-if="modelValue === 10" class="w-8 h-8 mr-4" />
            {{ label }}
        </ot-subheader>
        <ot-slider
            :model-value="modelValue"
            :min="0"
            :max="10"
            :step="1"
            show-labels
            @update:model-value="$emit('update:modelValue', $event)"
        />
    </div>
</template>
